<div class="flex flex-col gap-4" [formGroup]="form()">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Deposit amount</mat-label>
    <span matTextPrefix>$&nbsp;</span>
    <input
      matInput
      type="number"
      formControlName="amountValue"
      [step]="amountStep"
      [attr.aria-label]="ariaLabelPrefix() + ' deposit amount'"
    />
    @if (form().controls.amountValue.hasError('required')) {
      <mat-error>Deposit amount is required</mat-error>
    }
    @if (form().controls.amountValue.hasError('min')) {
      <mat-error>Deposit amount must be greater than 0</mat-error>
    }
  </mat-form-field>

  @if (inheritedCaptureStrategyLabel(); as inheritedLabel) {
    <p class="!mb-0 text-sm opacity-70">
      Currently following the brand default:
      <strong>{{ inheritedLabel }}</strong> . Choosing below overrides it for
      this treatment only.
    </p>
  }

  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-label>{{ timingQuestion }}</mat-label>
    <mat-select
      formControlName="captureStrategy"
      [attr.aria-label]="ariaLabelPrefix() + ' deposit timing'"
    >
      @for (option of captureStrategyOptions; track option.value) {
        <mat-option [value]="option.value">
          <div class="flex flex-col py-1">
            <span>{{ option.label }}</span>
            <span class="mt-0.5 text-sm opacity-70">
              {{ option.description }}
            </span>
          </div>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-label>Booking types</mat-label>
    <mat-select
      formControlName="appliesTo"
      multiple
      placeholder="Same as default"
      [attr.aria-label]="ariaLabelPrefix() + ' deposit booking types'"
    >
      @for (context of bookingContexts; track context) {
        <mat-option [value]="context">
          {{ bookingContextLabels[context] }}
        </mat-option>
      }
    </mat-select>
    <mat-hint>Leave empty to use the default booking types.</mat-hint>
  </mat-form-field>

  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-label>Deposit required on</mat-label>
    <mat-select
      formControlName="depositRequiredDays"
      multiple
      [attr.aria-label]="ariaLabelPrefix() + ' deposit required days'"
    >
      @for (day of depositRequiredDays; track day) {
        <mat-option [value]="day">{{ day | titlecase }}</mat-option>
      }
    </mat-select>
    <mat-hint>Select every day that requires a deposit.</mat-hint>
    @if (form().controls.depositRequiredDays.hasError('required')) {
      <mat-error>Select at least one day</mat-error>
    }
  </mat-form-field>
</div>
